<script lang="ts">

  import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, } from "$lib/components/ui/dialog"
  import { ImageWithFallback } from "$lib/components/ui/image-with-fallback"
  import { Label } from "$lib/components/ui/label"
  import { cn } from "$lib/utils"
  import type { Product } from "../_types"

  let { open, product, setOpen }: {
    open: boolean
    product: Product
    setOpen: (open: boolean) => void
  } = $props()

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="relative p-0 w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}
  >
    <DialogHeader class="hidden">
      <DialogTitle>Detail Produk</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <ImageWithFallback
      class="h-96 rounded-lg rounded-b-none"
      src={product.image_url}
      alt={product.name}
    />
    <div class="p-4 pt-0 space-y-3">
      <div>
        <Label>Nomor</Label>
        <div class="text-desc font-mono">{product.number}</div>
      </div>
      <div>
        <Label>Nama</Label>
        <div class="text-desc">{product.name}</div>
      </div>
      <div class="flex">
        <div class="flex-1">
          <Label>Harga</Label>
          <div>
            <span>{product.price_currency}</span>
            <span class="text-desc font-mono">
                {product.price || "-"}
              </span>
          </div>
        </div>
        <div class="flex-1">
          <Label>Satuan</Label>
          <div class="text-desc">{product.unit.name || "-"}</div>
        </div>
      </div>
      <div>
        <Label>Isi</Label>
        <ul class={cn(
              "list-disc before:block",
              product.contents.isEmpty() && "before:content-['-']",
            )}
        >
          {#each product.contents as content, index (index)}
            <li class="ms-4">{content}</li>
          {/each}
        </ul>
      </div>
      <div>
        <Label>Ringkasan</Label>
        <div>{product.description}</div>
      </div>
      <div>
        <Label>Status</Label>
        <div>{product.status ? "Aktif" : "Tidak"}</div>
      </div>
    </div>
  </DialogContent>
</Dialog>
